<template>
  <div class="safetyContent">
    <Form ref="formCustom" label-position="right" :model="formCustom" :rules="ruleCustom" :label-width="200" style="margin-top: 50px">
        <FormItem label="新密码：" prop="passwd">
            <Input type="password" v-model="formCustom.passwd"></Input>
        </FormItem>
        <FormItem label="再次输入新密码：" prop="passwdCheck">
            <Input type="password" v-model="formCustom.passwdCheck"></Input>
        </FormItem>
        <FormItem>
            <Button class="safetyBtn" type="primary" @click="handleSubmit('formCustom')">修改密码</Button>
        </FormItem>
    </Form>
  </div>
</template>

<script>
export default {
  data () {
    const validatePass = (rule, value, callback) => {
        if (value === '') {
            callback(new Error('请输入新密码'));
        } else {
            if (this.formCustom.passwdCheck !== '') {
                // 对第二个密码框单独验证
                this.$refs.formCustom.validateField('passwdCheck');
            }
            callback();
        }
    };
    const validatePassCheck = (rule, value, callback) => {
        if (value === '') {
            callback(new Error('请再次输入您的新密码'));
        } else if (value !== this.formCustom.passwd) {
            callback(new Error('两次输入的密码不匹配!'));
        } else {
            callback();
        }
    };
      return {
        formCustom: {
            passwd: '',
            passwdCheck: ''
        },
        ruleCustom: {
            passwd: [
                { validator: validatePass, trigger: 'blur' },
                { min: 6, message: "密码不能少于6位", trigger: "blur" }
            ],
            passwdCheck: [
                { validator: validatePassCheck, trigger: 'blur' }
            ],
        }
      }
    },
    methods: {
        handleSubmit (name) {
            let idNumberType = sessionStorage.getItem("idNumberType");
            let idCard = sessionStorage.getItem('idCard');
            this.$refs[name].validate((valid) => {
                if (valid) {
                    var _this = this
                    _this.$http.post("retire-school-manage/login/updateIdcardLogin", {
                      id: _this.$store.state.studentId,
                      idNumberType: idNumberType,
                        idCard: idCard.replace("x", "X"), // 身份证号
                        password: _this.formCustom.passwdCheck,
                    }).then(res => {
                        if (res.data.status == 2000) {
                            this.$Message.info({
                                content: '修改成功，2秒后将跳转至登录页面',
                                duration: 2
                            })
                            setTimeout(times => {
                                _this.$router.push({ path: '/login' })
                            }, 2000)
                        }
                    }).catch(err => {
                        console.log(err)
                    })
                } else {
                    this.$CustomMessageError('Fail!')
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
@import '../../styles/base/_variables.less';

  .safetyContent {
    height: calc(100vh - @mobile-header-footer-height);
    margin: auto;
    padding: 0 15px;
    box-sizing: border-box;
    overflow-y: auto;
    max-width: 800px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .safetyContent /deep/ form {
    margin-top: 50px;
    width: 100%;
  }

  .safetyContent /deep/ .ivu-form-item {
    margin-bottom: 24px;
  }

  .safetyContent /deep/ .ivu-input-wrapper {
    width: 400px;
  }

  .safetyContent /deep/ .ivu-input {
    height: 48px;
    line-height: 48px;
  }

  .safetyContent /deep/ .ivu-form-item-label {
    font-size: 16px;
    color: #333;
    font-weight: 500;
  }

  .safetyContent .safetyBtn {
    font-size: 18px;
    width: 260px;
    height: 60px;
    margin-top: 30px;
  }

  .safetyContent /deep/ .ivu-form-item-error-tip {
    font-size: 13px;
    padding-top: 4px;
  }

  @media screen and (max-width: 768px) {
    .safetyContent {
      width: 100%;
      height: calc(100vh - @mobile-header-footer-height);
      min-height: 350px;
      padding: 0 16px;
      max-width: none;
      display: block;
    }

    .safetyContent /deep/ form {
      margin-top: 16px;
    }

    .safetyContent /deep/ .ivu-form-item {
      margin-bottom: 20px;
    }

    .safetyContent /deep/ .ivu-form-item-label {
      text-align: left;
      padding: 0 0 10px 0;
      width: auto !important;
      font-size: 16px;
      line-height: 1.5;
    }

    .safetyContent /deep/ .ivu-input-wrapper {
      width: 100%;
    }

    .safetyContent /deep/ .ivu-input {
      height: 44px;
      line-height: 44px;
      font-size: 15px;
    }

    .safetyContent /deep/ .ivu-form-item-content {
      margin-left: 0 !important;
    }

    .safetyContent .safetyBtn {
      width: 100%;
      margin: 0;
      height: 46px;
      font-size: 16px;
      border-radius: 6px;
    }
  }

  @media screen and (max-width: 375px) {
    .safetyContent /deep/ .ivu-form-item-label {
      font-size: 15px;
    }

    .safetyContent /deep/ .ivu-input {
      font-size: 14px;
    }
  }
</style>
